export default {
    positionId: 'รหัสตำแหน่ง',
    name: 'ชื่อตำแหน่ง',
    shortName: 'ชื่อย่อ',
    searchText: 'ค้นหาโดยตำแหน่ง',
    search: 'ค้นหา'
}
